function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import MultipleChoicePoll from './multiple_choice_poll';
import Responds from './mixins/_responds';
import URI from 'urijs';

var RankingPoll = /*#__PURE__*/function (_MultipleChoicePoll) {
  _inheritsLoose(RankingPoll, _MultipleChoicePoll);

  function RankingPoll() {
    return _MultipleChoicePoll.apply(this, arguments) || this;
  }

  var _proto = RankingPoll.prototype;

  _proto.initialize = function initialize(options) {
    if (options === void 0) {
      options = {};
    }

    _MultipleChoicePoll.prototype.initialize.apply(this, arguments);

    this.include(Responds);
    /*
     * Needed for compatibility with old backbone stuff in Rails. See
     * `app/assets/javascripts/lib/backbone/models/poll.js.coffee` in the
     * rails app for details.
     * TODO: Remove this once the old backbone stuff in Rails has been removed.
     */

    this.model_type = this.type();
  };

  _proto.summaryTableUrl = function summaryTableUrl() {
    return undefined;
  };

  _proto.responseUrl = function responseUrl() {
    var permalink = this.get('permalink');
    return URI('/').segment(this.type() + 's').segment(permalink).segment('results.json').toString();
  };

  _proto.sendToListUrl = function sendToListUrl() {
    return undefined;
  };

  _createClass(RankingPoll, [{
    key: "defaultType",
    get: function get() {
      return 'ranking_poll';
    }
  }]);

  return RankingPoll;
}(MultipleChoicePoll);

export { RankingPoll as default };